import React from 'react';

// Menus render in a portal, but React still bubbles their events up to the
// canvas: a press would start dragging the block (the drag library's cancel
// check walks the DOM, which doesn't lead back to the menu's button), and a
// click outside the grid item's DOM would clear the selection. Wrap a menu's
// options in this to stop them.
const MenuEventBoundary = ({ children }: { children: React.ReactNode }) => (
  <div
    onMouseDown={(e) => e.stopPropagation()}
    onClick={(e) => e.stopPropagation()}
  >
    {children}
  </div>
);

export default MenuEventBoundary;
